document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-cp-page]').forEach((page) => {
    const gallery = Array.from(page.querySelectorAll('[data-cp-gallery-image]'));
    const thumbs = Array.from(page.querySelectorAll('[data-cp-thumb]'));
    let selected = 0;

    const selectImage = (index) => {
      if (!gallery.length) return;
      selected = (index + gallery.length) % gallery.length;
      gallery.forEach((image, imageIndex) => {
        const isSelected = imageIndex === selected;
        image.toggleAttribute('hidden', !isSelected);
        image.classList.toggle('is-selected', isSelected);
        image.setAttribute('aria-hidden', String(!isSelected));
      });
      thumbs.forEach((thumb, thumbIndex) => {
        const isSelected = thumbIndex === selected;
        thumb.classList.toggle('is-selected', isSelected);
        thumb.setAttribute('aria-pressed', String(isSelected));
      });
    };

    page.querySelector('[data-cp-prev]')?.addEventListener('click', () => selectImage(selected - 1));
    page.querySelector('[data-cp-next]')?.addEventListener('click', () => selectImage(selected + 1));
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => selectImage(index)));

    const mainImage = page.querySelector('.cp-main-image');
    let touchStartX = null;
    mainImage?.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0]?.clientX ?? null;
    }, { passive: true });
    mainImage?.addEventListener('touchend', (event) => {
      if (touchStartX === null) return;
      const distance = (event.changedTouches[0]?.clientX ?? touchStartX) - touchStartX;
      if (Math.abs(distance) > 45) selectImage(selected + (distance < 0 ? 1 : -1));
      touchStartX = null;
    }, { passive: true });

    const idInput = page.querySelector('input[name="id"]');
    const price = page.querySelector('[data-cp-price]');
    const compare = page.querySelector('[data-cp-compare]');
    const savings = page.querySelector('[data-cp-save]');
    const addButtons = Array.from(page.querySelectorAll('[data-cp-add]'));
    const primaryAddButton = page.querySelector('[data-cp-primary-add]');
    const stickyAddButton = page.querySelector('[data-cp-sticky-add]');
    const variantButtons = Array.from(page.querySelectorAll('[data-cp-variant]'));

    variantButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const variantId = button.dataset.variantId;
        if (!variantId || !idInput) return;
        idInput.value = variantId;
        variantButtons.forEach((item) => item.classList.toggle('is-selected', item === button));
        variantButtons.forEach((item) => item.setAttribute('aria-checked', String(item === button)));
        if (price && button.dataset.price) price.textContent = button.dataset.price;
        if (compare && button.dataset.compare) compare.textContent = button.dataset.compare;
        if (savings && button.dataset.savings) savings.textContent = `SAVE ${button.dataset.savings}`;
        addButtons.forEach((addButton) => {
          addButton.disabled = button.dataset.available !== 'true';
          addButton.textContent = button.dataset.available === 'true' ? '✓ Add To Cart' : 'Sold Out';
        });
      });
    });

    if (primaryAddButton && stickyAddButton && 'IntersectionObserver' in window) {
      const stickyObserver = new IntersectionObserver(([entry]) => {
        stickyAddButton.hidden = window.innerWidth > 580 || entry.isIntersecting || entry.boundingClientRect.top > 0;
      });
      stickyObserver.observe(primaryAddButton);
    }

    const menuButton = page.querySelector('[data-cp-menu-button]');
    const menu = page.querySelector('[data-cp-mobile-menu]');
    menuButton?.addEventListener('click', () => {
      const isOpen = menu?.toggleAttribute('hidden');
      menuButton.setAttribute('aria-expanded', String(!isOpen));
    });
  });

  document.querySelectorAll('[data-cp-quantity]').forEach((picker) => {
    const input = picker.querySelector('input');
    const form = picker.closest('form');
    if (!input || !form) return;

    picker.querySelector('[data-cp-minus]')?.addEventListener('click', () => {
      input.value = String(Math.max(1, Number(input.value) - 1));
      form.requestSubmit();
    });

    picker.querySelector('[data-cp-plus]')?.addEventListener('click', () => {
      input.value = String(Number(input.value) + 1);
      form.requestSubmit();
    });
  });

  const cartTimer = document.querySelector('[data-cp-cart-timer]');
  if (cartTimer) {
    const urgency = cartTimer.closest('[data-cp-cart-urgency]');
    const timerKey = 'cpCartReservationExpiresAt';
    const duration = 10 * 60 * 1000;
    let expiresAt = Number(sessionStorage.getItem(timerKey));
    if (!expiresAt || expiresAt <= Date.now()) {
      expiresAt = Date.now() + duration;
      sessionStorage.setItem(timerKey, String(expiresAt));
    }

    const updateTimer = () => {
      const remaining = Math.max(0, expiresAt - Date.now());
      const totalSeconds = Math.ceil(remaining / 1000);
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      cartTimer.textContent = `${minutes}:${String(seconds).padStart(2, '0')}`;
      if (remaining <= 0) {
        urgency?.classList.add('is-expired');
        cartTimer.textContent = cartTimer.dataset.expiredLabel || 'Reservation window expired';
        return false;
      }
      return true;
    };

    updateTimer();
    const timerInterval = window.setInterval(() => {
      if (!updateTimer()) window.clearInterval(timerInterval);
    }, 1000);
  }
});
